// @flow

import _ from 'lodash';

import ko from 'rgs-knockout';

import { scrollTo } from 'app/v2/utils';
import type { AdaptiveTableViewModelParams } from '../view-model';

export default (params: AdaptiveTableViewModelParams, elementContent: any) => {
	const canScroll = () => params.model.pagination.hasPaginationChanges();
	const scrollableElement = () => elementContent.element;
	const shouldScrollWork = () => params.model.isScrollEnabled;

	ko.computed(() => {
		if (shouldScrollWork() && canScroll()) {
			_.delay(() => scrollTo(scrollableElement()), 200); // smooth :)
		}
	}, { disposeWhenNodeIsRemoved: scrollableElement() });
};
